<template>
    <div>
        <el-dialog title="奖励配置" fullscreen :visible.sync="rewardConfigDialogVisible" @open="openDialog"
                   @close="closeDialog" :close-on-click-modal="false">
            <!--<el-button type="danger" @click="addPoolDetailDialog" style="margin: 20px 0">增 加</el-button>-->
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="depositCoin" fixed="left" label="币种矿池"></el-table-column>
                <el-table-column prop="reward" label="奖励金额"></el-table-column>
                <el-table-column prop="timeSlot" label="时间">
                    <template slot-scope="scope">
                        <span>第{{scope.row.timeSlot}}天</span>
                    </template>
                </el-table-column>
                <el-table-column prop="grantStatus" label="发放情况">
                    <template slot-scope="scope">
                        <span v-if="scope.row.grantStatus==1">已发放</span>
                        <span v-if="scope.row.grantStatus==0">未发放</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="200">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="updatePoolDialog(scope.row)">修改</el-button>
                        <!--<el-button type="danger" @click="deletePool(scope.row.id)">删除</el-button>-->
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>


            <!--新增或修改弹框-->
            <el-dialog :title="title" :visible.sync="dialogVisible" width="800px" @close="clearData"
                       :close-on-click-modal="false" :modal-append-to-body="false" :modal="false">
                <el-form label-width="150px" :model="addData" :rules="addRules" ref="addForm">
                    <el-form-item label="币挖矿关联ID：" prop="poolId" style="padding-top: 20px">
                        <el-input v-model="addData.poolId" placeholder="币挖矿关联id" disabled
                                  style="width: 500px"></el-input>
                    </el-form-item>
                    <el-form-item label="奖励数量：" prop="reward" style="padding-top: 20px">
                        <el-input v-model="addData.reward" placeholder="奖励数量(正整数：0＜X≤999999999)"
                                  style="width: 500px"></el-input>
                    </el-form-item>
                    <el-form-item label="时间段：" prop="timeSlot" style="padding-top: 20px">
                        <el-input v-model="addData.timeSlot" placeholder="时间段(正整数：0＜X≤9999)"
                                  style="width: 500px"></el-input>
                    </el-form-item>

                </el-form>

                <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addPoolDetail">确 定</el-button>
            </span>
            </el-dialog>
        </el-dialog>


    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import {mapMutations, mapState, mapGetters} from 'vuex';

    export default {
        name: "RewardConfig",
        data() {
            return {
                dataList: [],
                total: 0,
                queryParams: {poolId: "", page: 1, size: 10},
                title: "",
                dialogVisible: false,
                loading: false,
                addData: {
                    id: "",
                    poolId: "",
                    reward: "",
                    timeSlot: ""
                },
                addRules: {
                    "poolId": [{required: true, message: "币挖矿关联id不能为空"}],
                    "reward": [{required: true, message: "奖励数量不能为空"}],
                    "timeSlot": [{required: true, message: "时间段不能为空"}]
                },
            }
        },
        computed: {
            ...mapState("NewCoin", ["rewardConfigDialogVisible"])
        },
        methods: {
            ...mapMutations("NewCoin", ["setRewardConfigDialogVisible", "setPoolId"]),
            ...mapGetters("NewCoin", ["getPoolId"]),
            openDialog() {
                this.queryParams.poolId = this.getPoolId();
                api.getNewCoinPoolDetailPage(this.queryParams).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            closeDialog() {
                this.setRewardConfigDialogVisible(false);
                this.setPoolId(-1);
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.openDialog();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.openDialog();
            },
            updatePoolDialog(row) {
                this.addData = {
                    id: row.id,
                    poolId: this.getPoolId(),
                    reward: row.reward,
                    timeSlot: row.timeSlot
                };
                this.dialogVisible = true;
            },
            addPoolDetailDialog() {
                this.addData.poolId = this.getPoolId();
                this.dialogVisible = true;
            },
            addPoolDetail() {
                this.$refs["addForm"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        api.addOrUpdatePoolDetail(this.addData).then(({data}) => {
                            this.$message.success('操作成功!');
                            this.loading = false;
                            this.dialogVisible = false;
                            this.openDialog();
                        });
                        setTimeout(() => {
                            this.loading = false;
                        },1000);
                    }
                });
            },
            deletePool(id) {
                this.$confirm('确认删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deletePoolDetail({id: id}).then(() => {
                        this.$message.success('操作成功');
                        this.openDialog();
                    });
                }).catch(() => {
                });
            },
            clearData() {
                this.$refs["addForm"].resetFields();
                this.loading = false;
                this.addData = {
                    id: "",
                    poolId: "",
                    reward: "",
                    timeSlot: ""
                };
            }
        }
    }
</script>

<style scoped>

</style>